/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Connected_Sources_DescInputs */

const es_tyc_definitions_connected_sources_desc = /** @type {(inputs: Tyc_Definitions_Connected_Sources_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios de terceros integrados con Nexata mediante autorizacion explicita del Usuario.`)
};

const en_tyc_definitions_connected_sources_desc = /** @type {(inputs: Tyc_Definitions_Connected_Sources_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third-party services integrated with Nexata through explicit User authorization.`)
};

/**
* | output |
* | --- |
* | "Third-party services integrated with Nexata through explicit User authorization." |
*
* @param {Tyc_Definitions_Connected_Sources_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_connected_sources_desc = /** @type {((inputs?: Tyc_Definitions_Connected_Sources_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Connected_Sources_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_connected_sources_desc(inputs)
	return en_tyc_definitions_connected_sources_desc(inputs)
});
export { tyc_definitions_connected_sources_desc as "tyc.definitions.connected_sources_desc" }